/**
 * Maps routes to domain/epic context for chatbot metadata filtering.
 * Used by ChatbotContext to automatically detect the user's current page context.
 */
export const ROUTE_CONTEXT = {
  '/manager/overview': { domain: 'practice-pulse', epic: 'E-PP', pageName: 'Practice Pulse', persona: 'manager' },
  '/manager/staffing': { domain: 'staffing', epic: 'E-ST', pageName: 'Staffing Dashboard', persona: 'manager' },
  '/manager/finance': { domain: 'finance', epic: 'E-FT', pageName: 'Financial Tracking', persona: 'manager' },
  '/manager/quality': { domain: 'quality', epic: 'E-QR', pageName: 'Quality & Regulatory', persona: 'manager' },
  '/manager/quality-regulatory': { domain: 'quality', epic: 'E-QR', pageName: 'Quality & Regulatory', persona: 'manager' },
  '/manager/access': { domain: 'scheduling', epic: 'E-SA', pageName: 'Scheduling & Access', persona: 'manager' },
  '/manager/consumer-insights': { domain: 'consumer-insights', epic: 'E-CI', pageName: 'Consumer Insights', persona: 'manager' },
  '/manager/practice-management': { domain: 'practice-management', epic: 'E-PM', pageName: 'Practice Management', persona: 'manager' },
  '/manager/population-health': { domain: 'population-health', epic: 'E-PH', pageName: 'Population Health', persona: 'manager' },
  '/director/overview': { domain: 'network-pulse', epic: 'E-NP', pageName: 'Network Pulse', persona: 'director' },
  '/director/staffing': { domain: 'staffing', epic: 'E-ST', pageName: 'Director Staffing', persona: 'director' },
  '/queue': { domain: 'practice-management', epic: 'E-PM', pageName: 'Work Queue', persona: 'manager' },
  '/admin': { domain: 'admin', epic: 'E09', pageName: 'Admin Panel', persona: 'admin' },
  '/onboarding': { domain: 'admin', epic: 'E09', pageName: 'Onboarding Wizard', persona: 'admin' },
};

/**
 * Resolve context from a pathname. Falls back to a generic context.
 */
export function resolveRouteContext(pathname) {
  // Exact match first
  if (ROUTE_CONTEXT[pathname]) return ROUTE_CONTEXT[pathname];

  // Prefix match (handles sub-routes like /manager/staffing/details)
  for (const [route, ctx] of Object.entries(ROUTE_CONTEXT)) {
    if (pathname.startsWith(route)) return ctx;
  }

  return { domain: 'general', epic: '', pageName: 'NexoNurse', persona: 'manager' };
}
